import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Heading, Text, Accordion, AccordionItem } from "braid-design-system";
const Faqs = ({
  heading,
  subHeading,
  faqs,
  onToggleCallback
}) => {
  const toggleCallback = (faq, isExpanded, index) => {
    if (onToggleCallback) {
      onToggleCallback(faq, isExpanded, index);
    }
  };
  return /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
    heading ? /* @__PURE__ */ jsx(Heading, { level: "3", children: heading }) : null,
    subHeading ? /* @__PURE__ */ jsx(Text, { tone: "secondary", children: subHeading }) : null,
    /* @__PURE__ */ jsx(Accordion, { dividers: false, space: "large", tone: "neutral", children: faqs.map((faq, idx) => /* @__PURE__ */ jsx(
      AccordionItem,
      {
        label: faq.label,
        id: `acc_t${idx}`,
        onToggle: (isExpanded) => toggleCallback(faq, isExpanded, idx),
        children: /* @__PURE__ */ jsx(Text, { tone: "secondary", children: faq.copy })
      },
      `acc_t${idx}`
    )) })
  ] });
};
export {
  Faqs
};
